const gameInfoVersionTempId = "6E945655039611EF8E691070FD936D58";
const growFileTempId = "074E4F51F7D611EE8E691070FD936D58";
const growFileParentId = "8f658f99a009412ea462e96f68f632fd";
const defaultUserAvatar = "https://ljp-h5.oss-cn-hangzhou.aliyuncs.com/static/imgs/avatar.png";

export { defaultUserAvatar, gameInfoVersionTempId, growFileParentId, growFileTempId };
